import { useMemo } from 'react';
import { IComboBoxOption, SelectableOptionMenuItemType } from '@fluentui/react';

export function SortSelectedOptions(
    selectableOptions: IComboBoxOption[],
    selectedOptionTypes: string[],
    headerText: string
): IComboBoxOption[] {
    return useMemo(() => {
        const opts = selectableOptions.filter(
            (option) => option.key !== 'selectAll'
        );
        const selected = opts.filter((o) =>
            selectedOptionTypes.includes(o.key as string)
        );
        const unselected = opts.filter(
            (o) => !selectedOptionTypes.includes(o.key as string)
        );
        return [
            {
                key: 'selectAll',
                text: 'Select All',
                itemType: SelectableOptionMenuItemType.SelectAll,
            },
            {
                key: 'Header1',
                text: headerText,
                itemType: SelectableOptionMenuItemType.Header,
            },
            ...selected.concat(unselected),
        ];
    }, [selectableOptions, selectedOptionTypes]);
}
